// Dependencies
import axios from "axios";
import Cookies from "js-cookie";

// Project
import { getApiDomain } from "../Utils/getDomain";

const client = axios.create({
	baseURL: `${getApiDomain()}`,
	headers: {
		"Content-Type": "application/json",
		Authorization: Cookies.get("logan-auth-token"),
	},
	withCredentials: true,
});

const request = (config) => {
	const req = client.request({
		url: config.url,
		method: config.method || "GET",
		...(config.data ? { data: config.data } : {}),
		...(config.params ? { params: config.params } : {}),
		headers: {
			...client.defaults.headers,
			Authorization: Cookies.get("logan-auth-token"),
			...(config.headers ? config.headers : {}),
		},
		responseType: config.responseType || "json",
		onDownloadProgress: config.onDownloadProgress || undefined,
	});
	return req;
};

export default request;
